// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Депутатські запити» (Deputy requests, ключ `deputyreq`, група `oversight`). */
export const deputyRequestsManifest: IModuleManifest = {
  key: 'deputyreq',
  group: 'oversight',
  slug: 'deputy-requests',
  prefix: 'DRQ',
  name: { en: 'Deputy requests', uk: 'Депутатські запити' },
  entities: [
    { key: 'deputyreq', slug: 'deputyreq', name: { en: 'Deputy requests', uk: 'Депутатські запити' }, main: true },
    { key: 'request_addressee', slug: 'request-addressee', name: { en: 'Request Addressees', uk: 'Адресати' }, main: false },
    { key: 'request_answer', slug: 'request-answer', name: { en: 'Request Answers', uk: 'Відповіді' }, main: false },
    { key: 'request_reminder', slug: 'request-reminder', name: { en: 'Request Reminders', uk: 'Нагадування' }, main: false },
    { key: 'request_document', slug: 'request-document', name: { en: 'Request Documents', uk: 'Документи' }, main: false },
    { key: 'request_status', slug: 'request-status', name: { en: 'Request Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/deputyRequestsSlice').then((m) => m.deputyRequestsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
